import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import * as THREE from 'three';
import { FikoYTService } from '@/src/service/fikoyt.service';
import { FikoSahne } from '../FikoSahne';
import { FikoKonumlar } from './FikoKonumlar';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'fikoyt-konumlar',
  templateUrl: './konumlar.component.html',
  styleUrls: ['./konumlar.component.scss'],
  imports: [CommonModule, FormsModule]
})
export class KonumlarComponent implements OnDestroy {
  id_dialog = "dialogKonumlar" + this.FikoYT.fikoIdUret();
  /** */
  @Input() konumlar: FikoKonumlar;
  @Input() sahne: FikoSahne;
  @Input() pencere: any; // Dialog Core'dan gelen pencere referansı
  /** */
  ekleStr: string = "";

  subsDegisti: Subscription;
  constructor(public readonly FikoYT: FikoYTService, public readonly CD: ChangeDetectorRef) {
    this.subsDegisti = FikoYT.degisti.subscribe(() => {
      CD.detectChanges();
    })
  }


  tikandiEkleKonum() {
    const kameraJSON = this.sahne.anaGosterim.aktifKamera.toJSON() as any;

    const veri = {
      position: kameraJSON.object?.position || this.sahne.anaGosterim.aktifKamera.position.toArray(),
      quaternion: kameraJSON.object?.quaternion || this.sahne.anaGosterim.aktifKamera.quaternion.toArray(),
      scale: kameraJSON.object?.scale || this.sahne.anaGosterim.aktifKamera.scale.toArray(),
      ust: kameraJSON.object?.up || this.sahne.anaGosterim.aktifKamera.up.toArray(),
      yakinlik: kameraJSON.object?.zoom || this.sahne.anaGosterim.aktifKamera.zoom,
      hedef: this.sahne.anaGosterim.aktifKontrol.target.toArray(),
      oran: this.sahne.anaGosterim.canvas.nativeElement.clientWidth / this.sahne.anaGosterim.canvas.nativeElement.clientHeight,
      matriks: kameraJSON.object?.matrix || this.sahne.anaGosterim.aktifKamera.matrix.toArray()
    };

    this.konumlar.kaydet(this.ekleStr, null, veri);
    this.ekleStr = "";
    this.CD.detectChanges();
    this.FikoYT.degisti.emit();
  }

  sunumId: any = null;
  aktifKonum = 0;
  tiklandiSunum() {
    if (this.sunumId) clearInterval(this.sunumId)
    if (this.konumlar.liste.length < 0) {
      return
    }
    if (this.aktifKonum < this.konumlar.liste.length) {
      this.aktifKonum = 0
    }
    this.sunumId = setInterval(() => {
      if (this.aktifKonum >= this.konumlar.liste.length) {
        this.aktifKonum = 0
      }
      this.konumlar.liste[this.aktifKonum].git();
      this.aktifKonum += 1
    }, 4000);
  }

  /**
   * Sabit görünüme git (anlık olarak hesapla ve gitsin)
   */
  async gitSabitGorunum(gorunumTipi: 'isometrik' | 'ust' | 'alt' | 'on' | 'arka' | 'sag' | 'sol') {
    const gorunumler = (this.konumlar as any).hesaplaGorunumKonumlari();
    if (!gorunumler || !gorunumler[gorunumTipi]) {
      return;
    }

    const veri = gorunumler[gorunumTipi];
    const mevcutQua = this.sahne.anaGosterim.aktifKamera.quaternion;

    // Dot product hesapla
    const dotProduct = new THREE.Quaternion().copy(mevcutQua).dot(new THREE.Quaternion().fromArray(veri.quaternion as any));

    // Eğer çok zıt yönde ise (dot product < 0.1), önce izometrik'e git
    if (Math.abs(dotProduct) < 0.1 && gorunumTipi !== 'isometrik') {
      await (this.konumlar as any).gitVeri(gorunumler['isometrik'], 500);
      await (this.konumlar as any).gitVeri(veri, 500);
    } else {
      // Direkt git
      await (this.konumlar as any).gitVeri(veri);
    }
  }

  public kapa() {
    if (this.sunumId) clearInterval(this.sunumId)
    // Dialog core'ın kapa metodunu çağır
    // FikoDialogCore'dan { instance: this } şeklinde gelir
    if (this.pencere?.instance && typeof this.pencere.instance.kapa === 'function') {
      try {
        this.pencere.instance.kapa();
        return;
      } catch (error) {
      }
    }

    // Fallback: direkt pencere.kapa() dene (eski pattern için)
    if (this.pencere && typeof this.pencere.kapa === 'function') {
      try {
        this.pencere.kapa();
        return;
      } catch (error) {
      }
    }
  }

  ngOnDestroy(): void {
    $("#" + this.id_dialog).remove();
    this.subsDegisti.unsubscribe();
  }
}
